import { useEffect, useMemo, useState } from "react";
import api from "../services/api";
import { useUser } from "../context/UserContext";

export default function CustomerPortalRouteGate({ children }) {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [error, setError] = useState("");
  const accountType = String(user?.accountType || "internal").trim().toLowerCase();
  const isCustomerPortalUser = accountType === "customer_portal";

  useEffect(() => {
    if (isCustomerPortalUser) {
      setEnabled(true);
      setError("");
      setLoading(false);
      return;
    }

    let active = true;

    async function load() {
      try {
        setLoading(true);
        setError("");
        const res = await api.get("/tenant/settings");
        if (!active) return;
        setEnabled(Boolean(res?.data?.modules?.customerPortalEnabled));
      } catch (err) {
        if (!active) return;
        setEnabled(false);
        setError(err?.response?.data?.message || "KlantHub instellingen laden mislukt");
      } finally {
        if (active) setLoading(false);
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [isCustomerPortalUser]);

  const content = useMemo(() => {
    if (loading) {
      return (
        <div className="min-h-screen bg-slate-50 px-4 py-6 sm:px-6">
          <div className="mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-5 text-sm text-slate-500 shadow-sm">
            KlantHub laden...
          </div>
        </div>
      );
    }

    if (!enabled) {
      return (
        <div className="min-h-screen bg-slate-50 px-4 py-6 sm:px-6">
          <div className="mx-auto max-w-3xl rounded-2xl border border-amber-200 bg-amber-50 p-5 text-sm text-amber-900 shadow-sm">
            <p className="font-semibold">KlantHub staat uit voor deze tenant.</p>
            <p className="mt-1">
              Zet in tenant settings de moduleflag <code>customerPortalEnabled</code> aan.
            </p>
            {error ? <p className="mt-2 text-amber-800">Details: {error}</p> : null}
          </div>
        </div>
      );
    }

    return children;
  }, [children, enabled, error, loading]);

  return content;
}
